(function () {
  // Chọn đúng container cross-sell trong dialog collection
  const CONTAINER_SELECTOR = '.tee-dialog.tee-cross-sell-product-popup .tee-dcontent .tee-cross-sell-product-list';

  // Mượt hơn: ưu tiên jQuery animate; fallback dùng requestAnimationFrame với easing
  function smoothScrollElement(el, duration = 800) {
    if (!el) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      el.scrollTop = 0;
      return;
    }
    const start = el.scrollTop;
    if (start === 0) return;
    const startTime = performance.now(); // Returns a Perfomance object from Window
    const easeInOutQuad = (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t);
    let rafId;

    const cancel = () => {
      if (rafId) cancelAnimationFrame(rafId);
      el.removeEventListener('wheel', cancel, { passive: true });
      el.removeEventListener('touchstart', cancel, { passive: true });
    };

    const step = (now) => {
      const elapsed = now - startTime;
      const t = Math.min(1, elapsed / duration);
      const eased = easeInOutQuad(t);
      el.scrollTop = Math.round(start * (1 - eased));
      if (t < 1) {
        rafId = requestAnimationFrame(step);
      } else {
        cancel();
      }
    };

    el.addEventListener('wheel', cancel, { passive: true });
    el.addEventListener('touchstart', cancel, { passive: true });
    rafId = requestAnimationFrame(step);
  }

  function setupScrollTop(targetContainer) {
    const container = targetContainer.closest('.tee-dcontent');
    if (!container || container.dataset.teeibScrolltopInited === '1') return;
    container.dataset.teeibScrolltopInited = '1';

    // wrapper sticky ở đáy vùng cuộn
    const wrap = document.createElement('div');
    wrap.className = 'tee-scrolltop-wrap';
    const btn = document.createElement('button');
    const btnIcon = document.getElementById('tee-cross-sell-icon-wrapper');
    btn.type = 'button';
    btn.className = 'tee-scrolltop-btn';
    btn.setAttribute('aria-label', 'Scroll to top');
    btn.innerHTML = btnIcon.innerHTML ?? '↑';
    wrap.appendChild(btn);

    // thêm vào cuối container để sticky bám đáy
    container.appendChild(wrap);

    const update = () => {
      const canScroll = container.scrollHeight - container.clientHeight > 0;
      const show = container.scrollTop > 200;
      btn.classList.toggle('is-visible', canScroll && show);
    };

    // bắt sự kiện scroll, dùng requestAnimationFrame để tối ưu hiệu năng
    let ticking = false;
    container.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(() => {
            update();
            ticking = false;
          });
        }
      },
      { passive: true }
    );

    btn.addEventListener('click', (e) => {
      e.preventDefault();
      if (window.jQuery) {
        window.jQuery(container).stop(true).animate({ scrollTop: 0 }, 800, 'swing');
      } else {
        smoothScrollElement(container, 800);
      }
    });

    // lần đầu
    update();
  }

  // Bắt khi node mới được thêm (popup mở hoặc DOM reload)
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node?.matches(CONTAINER_SELECTOR)) {
          setupScrollTop(node);
        }
        const containers = node?.querySelectorAll(CONTAINER_SELECTOR) ?? [];
        for (const el of containers) {
          setupScrollTop(el);
        }
      }
    }
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
    // nếu container đã có sẵn (trường hợp popup render ngay)
    const existingContainers = document.querySelectorAll(CONTAINER_SELECTOR);
    for (const el of existingContainers) {
      setupScrollTop(el);
    }
  }
})();
